import React, { useState, useEffect } from "react";
import { BiSolidDashboard, BiUser, BiUserPin, BiLogOut } from "react-icons/bi";
import { FiMenu, FiPhoneCall, FiClock, FiSettings, FiRefreshCw } from "react-icons/fi";
import { MdDoNotDisturb, MdOutlinePendingActions, MdCallHistory } from "react-icons/md";
import axios from "axios";






const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, setView, handleLogout, user }) => {
  const [credits, setCredits] = useState(null);

  useEffect(() => {
    const fetchCredits = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_API}/api/elevenlabs/credits`);
        setCredits(response.data);
      } catch (error) {
        console.error("Error fetching credits in sidebar:", error);
      }
    };
    fetchCredits();
  }, []);

  return (
    <aside
      className={`${isSidebarOpen ? "w-60" : "w-16"
        } bg-gray-800 text-white transition-all duration-300 ease-in-out flex flex-col`}
      aria-label="Sidebar"
    >
      <div className="p-4">
        <div className="flex items-center justify-between">
          {isSidebarOpen && <h2 style={{ color: "#ffffff", fontSize: "35px" }} className="login-title">
            <span style={{ color: "#007bff", fontSize: "37px" }}>C</span>allCentri
          </h2>}
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="rounded hover:bg-gray-700 transition-colors"
            aria-label="Toggle sidebar"
          >
            <FiMenu size={24} />
          </button>
        </div>
      </div>
      <nav className="mt-4 flex-grow">
        <div className="px-4 py-2 text-gray-400 uppercase text-sm">
          {isSidebarOpen && "Call Room"}
        </div>
        <ul className="space-y-2 px-2">

          <li>
            <button
              onClick={() => setView("Dashboard")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="CRM"
            >
              <BiSolidDashboard size={24} />
              {isSidebarOpen && <span className="ml-3">Dashboard</span>}
            </button>
          </li>
          {/* <li>
            <button
              onClick={() => setView("Agents-CCE")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="Agents-CCE"
            >
    <MdOutlinePendingActions size={24} />
              {isSidebarOpen && <span className="ml-3">Agents-CCE</span>}
            </button>
          </li> */}

          {/* <li>
            <button
              onClick={() => setView("CRM")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="CRM"
            >
              <BiUserPin size={24} />
              {isSidebarOpen && <span className="ml-3">CRM</span>}
            </button>
          </li> */}





          <li>
            <button
              onClick={() => setView("TotalCustomers")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="TotalCustomers"
            >
              <BiSolidDashboard size={24} />
              {isSidebarOpen && <span className="ml-3">Clients</span>}
            </button>
          </li>











          <li>
            <button
              onClick={() => setView("CallHistory")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="CallHistory"
            >
              <BiSolidDashboard size={24} />
              {isSidebarOpen && <span className="ml-3">History</span>}
            </button>
          </li>


          {/* <li>
  <button
    // onClick={() => setView("DoNotDisturb")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="DoNotDisturb"
  >
     <MdOutlinePendingActions size={24} />
   
    {isSidebarOpen && <span className="ml-3">Call Queus</span>}
  </button>
</li> */}

          {/* <li>
  <button
    // onClick={() => setView("WaitingList")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="WaitingList"
  >
    <MdOutlinePendingActions size={24} />
    {isSidebarOpen && <span className="ml-3">Call Notes</span>}
  </button>
</li>  */}


          {/* <li>
  <button
    // onClick={() => setView("WaitingList")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="WaitingList"
  >
    <MdOutlinePendingActions size={24} />
    {isSidebarOpen && <span className="ml-3">Reports</span>}
  </button>
</li>  */}

          {/* <li>
  <button
    onClick={() => setView("DoNotDisturb")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="DoNotDisturb"
  >
     <MdDoNotDisturb size={24} />
    {isSidebarOpen && <span className="ml-3">DNC List</span>}
  </button>
</li>  */}




          <li>
            <button
              onClick={() => setView("ElevenLabsSettings")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors text-blue-400"
              aria-label="ElevenLabs Settings"
            >
              <FiSettings size={24} />
              {isSidebarOpen && <span className="ml-3">AI Settings</span>}
            </button>
          </li>
        </ul>
      </nav>

      <div className="mt-auto px-3">
        {isSidebarOpen && credits && (
          <div className="mx-2 mb-4 p-3 bg-gray-900/50 rounded-lg border border-gray-700">
            <div className="flex justify-between items-center text-[10px] uppercase tracking-wider text-gray-400 mb-1">
              <span>AI Credits</span>
              <span className="text-blue-400">{Math.round((credits.character_count / credits.character_limit) * 100)}%</span>
            </div>
            <div className="h-1.5 w-full bg-gray-700 rounded-full overflow-hidden mb-2">
              <div
                className="h-full bg-blue-500 transition-all duration-500"
                style={{ width: `${(credits.character_count / credits.character_limit) * 100}%` }}
              ></div>
            </div>
            <div className="text-xs font-mono text-gray-300">
              {Math.round(credits.remaining / 1000)}k left
            </div>
          </div>
        )}
        <button
          onClick={handleLogout}
          className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
          aria-label="Logout"
        >
          <BiLogOut size={24} />
          {isSidebarOpen && <span className="ml-3">Logout</span>}
        </button>

        <div className="flex items-center w-full p-2 rounded transition-colors mt-4">
          <BiUser size={24} />
          {isSidebarOpen && <span className="ml-3">{user}</span>}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
